export default __webpack_public_path__ + "static/media/xcINTR.3513a335.png";